module.exports = __webpack_public_path__ + "static/media/krFlag.cf052eb1.svg";